// Pure diff between an existing Set of marker keys and the next desired list of keys.
// Returns the keys that need to be created (`added`) and those that need to be torn
// down (`removed`). Keys present in both are untouched.
export const diffMarkerKeys = (oldKeys, nextKeys) => {
  const nextSet = new Set(nextKeys)
  const added = new Set()
  const removed = new Set()

  for (const k of nextSet) {
    if (!oldKeys.has(k)) added.add(k)
  }
  for (const k of oldKeys) {
    if (!nextSet.has(k)) removed.add(k)
  }

  return { added, removed }
}
